import React, {useEffect} from 'react';
import './App.css'
import SupportFeatured from './components/support-featured'



function Support() {
  useEffect(() => {
  window.scrollTo(0, 0)
}, [])
  return (
   <>
   <SupportFeatured />
   </>
  );
};

export default Support;
